import { Button, Box } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';

const FilterBadge = ({ filterDef, value, onClick }) => {
  if (!filterDef) return <div />;

  return (
    <Box component="fieldset" sx={{ padding: '0px', display: 'flex', justifyContent: 'center' }}>
      <legend style={{ fontSize: '12px', whiteSpace: 'nowrap', margin: '0 auto' }}>
        {filterDef.label}
      </legend>
      <Button key={filterDef.key} onClick={onClick} endIcon={<ClearIcon />}>
        {filterDef.render(value)}
      </Button>
    </Box>
  );
};

export default FilterBadge;
